export const DEFAULT_ID_KEY = 'id';
//# sourceMappingURL=defaultIDKey.js.map